import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { MainContainer } from "../../components/MainContainerComp";
import { linkStyle } from './styled';

export const OnlineApplications = () => (
  <MainContainer>
    <Box>
      <Box>
        <Typography className='sub-title' sx={{ mt: 4, mb: 1 }}>Human Resources</Typography>
        <Typography
          variant='document-hyperlink'
          component={Link}
          to='/paid-medical-leave-request'
          sx={linkStyle}
        >
          <OpenInNewIcon />
          Online Application for Paid Medical Leave
        </Typography>
        <Typography
          sx={linkStyle}
          component={Link}
          to='/paid-personal-leave-request'
          variant='document-hyperlink'
        >
          <OpenInNewIcon />
          Online Application for Paid Personal Leave
        </Typography>
      </Box>
      <Box>
        <Typography className='sub-title' sx={{ mt: 4, mb: 1 }}>Training</Typography>
        Coming Soon
      </Box>
    </Box>
  </MainContainer>
)